import React, { lazy, useEffect, Suspense } from 'react';
import { useApolloClient } from '@apollo/react-hooks';

import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from 'react-router-dom';

import { useAuth0 } from '@iso/config/react-auth0-spa';
import LogoLoader from '@iso/components/utility/LogoLoader';

import ErrorBoundary from './ErrorBoundary';
import { PUBLIC_ROUTE } from './route.constants';
const Dashboard = lazy(() => import('./containers/Dashboard/Dashboard'));
// const Dashboard = lazy(() => import('./containers/CampaignPromises/CampaignPromises'))

const publicRoutes = [
  {
    exact: true,
    path: PUBLIC_ROUTE.LANDING,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn')),
  },
];

function PrivateRoute({ children, ...rest }) {
  const client = useApolloClient();

  const { loading, user, isAuthenticated } = useAuth0();

  const roles = user && user['https://wahjef.com/roles'];

  useEffect(() => {
    client.writeData({
      data: {
        isAdmin: roles && roles.includes('admin'),
        isEditor: roles && roles.includes('editor'),
        isSuperAdmin: roles && roles.includes('super-admin'),
      },
    });
  }, [roles, client]);

  if (loading) {
    return <LogoLoader />;
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default function Routes() {
  const { user } = useAuth0();

  useEffect(() => {
    if (user) {
      window.analytics.identify(user.sub, {
        name: user.name,
        email: user.email,
      });
    }
  }, [user]);

  return (
    <ErrorBoundary>
      <Suspense fallback={<LogoLoader />}>
        <Router>
          <Switch>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))}
            <PrivateRoute path="/dashboard">
              <Dashboard />
            </PrivateRoute>
          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
